function FullPageErrorFallback({ error }) {
  return (
    <div
      css={{
        fontSize: "4em",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {error}
    </div>
  );
}
export { FullPageErrorFallback };
